import { Stack, Typography } from '@mui/material';
import KbdChip from '@watershed/ui-core/components/KbdChip';

export type CommandPaletteShortcutButtonProps = {
  description: string;
  onClick?: () => void;
} & (
  | {
      iconRepresentation?: undefined;
      textRepresentation: string;
    }
  | {
      iconRepresentation: React.ReactNode;
      textRepresentation?: undefined;
    }
);

export default function CommandPaletteShortcutButton({
  description,
  textRepresentation,
  iconRepresentation,
  onClick,
}: CommandPaletteShortcutButtonProps) {
  return (
    <Stack
      gap={0.75}
      direction="row"
      component="button"
      onClick={onClick}
      border="0"
      borderRadius="4px"
      py={0.5}
      pl={0.5}
      pr={1}
      bgcolor="transparent"
      alignItems="center"
      sx={{
        ':hover': {
          backgroundColor: (theme) => theme.palette.grey10,
          '& div': {
            backgroundColor: (theme) => theme.palette.grey20,
          },
        },
      }}
    >
      {textRepresentation ? (
        <KbdChip label={textRepresentation} />
      ) : (
        <Stack
          color={(theme) => theme.palette.grey50}
          component="span"
          mr="-2px"
        >
          {iconRepresentation}
        </Stack>
      )}
      <Typography
        variant="body3"
        sx={{ color: (theme) => theme.palette.grey50 }}
      >
        {description}
      </Typography>
    </Stack>
  );
}
